import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { Periodicidad } from '@/app/models/interface/periodicidad.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class PeriodicidadService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'periodicidad/';

  create(data: Partial<Periodicidad>) {
    return this.http.post<CustomResponse<Periodicidad>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  findAll(
    params?: HttpParams,
  ): Observable<PaginatorModel<Periodicidad[], HasPagination>> {
    return this.http
      .get<
        CustomResponse<PaginatorModel<Periodicidad[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;

          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<Periodicidad>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return d;
      }),
    );
  }

  update(capacitacion: Partial<Periodicidad>) {
    const url = this.url + capacitacion.id;
    return this.http.put<CustomResponse<Periodicidad>>(url, capacitacion).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return d;
      }),
    );
  }

  changeState(state: boolean, id: string) {
    const url = this.url + id;
    return this.http.patch<CustomResponse<Periodicidad>>(url, { state }).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return d;
      }),
    );
  }
}
